import React, { useState } from 'react';
import { AritoFormV2, AritoIcon, DialogV2, BottomActionBarV2 } from '@/components/custom/erp';
import { FormSchema, type FormValues, initialFormValues } from '../../schemas';
import type { DichVu, DichVuInput } from '@/types/schemas';
import { useServiceFormFieldState } from '../../hooks';
import ServiceForm from './ServiceForm';
import { FormMode } from '@/types/form';

interface ServiceDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: DichVu;
  onClose: () => void;
  onSubmit?: (data: DichVuInput) => void;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  zIndex?: number;
}

function ServiceDialog({
  open,
  mode,
  initialData,
  onClose,
  onSubmit,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick,
  zIndex
}: ServiceDialogProps) {
  const { state, actions } = useServiceFormFieldState(initialData);

  const handleSubmit = (data: FormValues & Partial<Pick<DichVuInput, 'gia_nt2' | 'gia_nt'>>) => {
    const formattedData = {
      ma_dv: data.ma_dv,
      ten_dv: data.ten_dv,
      ten_dv2: data.ten_dv2 || null,
      dvt: state.dvt?.uuid || null,
      tk_dt: state.tkDoanhThu?.uuid || null,
      tk_cp: state.tkChiPhi?.uuid || null,
      ma_thue: state.maThue?.uuid || null,
      gia_nt2: data.gia_nt2 || 0,
      gia_nt: data.gia_nt || 0,
      ma_cp: state.maChiPhi?.uuid || null,
      ma_phi: state.maPhi?.uuid || null,
      ma_bp: state.maBoPhan?.uuid || null,
      ma_hd: state.maHopDong?.uuid || null,
      ma_ku: state.kheUoc?.uuid || null,
      ma_vv: state.maVuViec?.uuid || null,
      status: data.status
    };
    onSubmit?.(formattedData as DichVuInput);
  };
  const title = mode === 'add' ? 'Thêm mới dịch vụ' : mode === 'edit' ? 'Sửa dịch vụ' : 'Xem chi tiết dịch vụ';

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={title}
        maxWidth='md'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={12} />}
        paperClassName='w-[min(900px,calc(100vw-16px))]'
        zIndex={zIndex}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialFormValues) as unknown as FormValues}
          className='w-full min-w-0 max-w-full'
          headerFields={<ServiceForm formMode={mode} serviceState={{ state, actions }} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onClose={onClose}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default ServiceDialog;
